/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { Component, Input, OnInit } from '@angular/core';
import { PositionService } from '@core/services/position/position.service';

@Component({
  selector: 'app-dynamic-form-card',
  templateUrl: './dynamic-form-card.component.html',
  styleUrls: ['./dynamic-form-card.component.scss']
})
export class DynamicFormCardComponent implements OnInit {
  @Input() title: string;

  @Input() subtitle: string;

  customerName: string;

  constructor(private positionService: PositionService) {}

  ngOnInit() {
    this.setCustomerName();
  }

  private setCustomerName(): void {
    this.customerName = this.positionService.getPosition().getCustomerName();
  }
}
